<template>
  <!-- <v-tooltip bottom> -->
  <!-- <template v-slot:activator="{ on, attrs }"> -->
  <div>
    <v-list-item 
      class="px-5"
      @click="signout" 
      style="cursor: pointer">
      <v-icon color="primary" left>
        mdi-logout
      </v-icon>
      <span>{{ $t("common.logout") }}</span>
    </v-list-item>
      <!-- <v-icon class="mx-4 black--text font-weight-bold" outlined color="dark"
        >mdi-logout</v-icon
      > -->
      <!-- <font-awesome-icon
        class="mx-4 black--text mt-1 signout-btn"
        :icon="['fas', 'sign-out-alt']"
      ></font-awesome-icon>
      v-on="on" v-bind="attrs"
    </span> -->
  </div>
  <!-- </template> -->
  <!-- <span>{{ $t("user.signOut") }}</span> -->
  <!-- </v-tooltip> -->
</template>

<script>
import { onLogout } from "@/plugins/vue-apollo.js";
import { getCurrentUser } from "../methods/helper.js";
export default {
  data() {
    return {
      user: null,
    };
  },

  created() {
    this.user = getCurrentUser.user;
  },
  methods: {
    signout() {
      onLogout(this.$apollo.provider.defaultClient);
      localStorage.removeItem("DONE_USER");
      localStorage.removeItem("DONE_USER_ROLE");
      localStorage.removeItem("DONE_USER_PERMISSIONS");
      this.$router.replace({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.signout-btn {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: center;
  letter-spacing: 0.4px;

  /* Light/PrimaryVariant */

  color: #002539;

}
</style>